<form [formGroup]="form" style="margin-top: 2.4375rem">
  <label class="page-title">MODIFICAR MIS DATOS</label>
  <mat-card>
    <mat-card-content>
      <div class="container">
        <app-error *ngIf="error"></app-error>

        <mat-grid-list cols="4" rowHeight="1rem" gutterSize="0px">
          <mat-grid-tile colspan="4"></mat-grid-tile>
          <mat-grid-tile>
            <div class="row">
              <span class="title">CAMBIAR CONTRASEÑA</span>
            </div>
          </mat-grid-tile>
          <mat-grid-tile colspan="4">
            <mat-divider></mat-divider>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="3" rowHeight="3.9rem" gutterSize="0px">
          <mat-grid-tile>
            <div class="row">
              <app-form-input-text
                [label]="'Contraseña Actual'"
                [type]="'password'"
                formControlName="claveOriginal"
                [messageError]="
                  claveOriginal.dirty || claveOriginal.touched
                    ? getErrorMessage(form, 'claveOriginal')
                    : ''
                "
              >
              </app-form-input-text>
            </div>
          </mat-grid-tile>

          <mat-grid-tile>
            <div class="row">
              <app-form-input-text
                [label]="'Nueva Contraseña'"
                [type]="'password'"
                formControlName="claveNueva"
                [messageError]="
                  claveNueva.dirty || claveNueva.touched
                    ? getErrorMessage(form, 'claveNueva')
                    : ''
                "
              >
              </app-form-input-text>
            </div>
          </mat-grid-tile>

          <mat-grid-tile>
            <div class="row">
              <app-form-input-text
                [label]="'Repite Nueva Contraseña'"
                [type]="'password'"
                formControlName="claveNuevaReingresada"
                [messageError]="
                  claveNuevaReingresada.dirty || claveNuevaReingresada.touched
                    ? getErrorMessage(form, 'claveNuevaReingresada')
                    : ''
                "
              >
              </app-form-input-text>
            </div>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="4" rowHeight="1.8rem" gutterSize="0px">
          <mat-grid-tile colspan="4">
            <mat-divider></mat-divider>
          </mat-grid-tile>

          <mat-grid-tile colspan="3"></mat-grid-tile>

          <mat-grid-tile>
            <div class="container-button">
              <button
                (click)="guardar()"
                [disabled]="!form.valid || !form.dirty"
                mat-flat-button
                class="button-detail"
              >
                Guardar
              </button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </mat-card-content>
  </mat-card>
</form>
